module.exports = __webpack_public_path__ + "static/img/TaskAdd_ok.f29f6cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TaskAdd_ok.jpg
// module id = lrMA
// module chunks = 1